import { useFormikContext } from 'formik'
import { useEffect } from 'react'

import { clearSupportDraft, saveSupportDraft } from '../../helpers/supportDraft'
import { SupportPageContext } from '../../helpers/supportLaunchContext'
import { SupportTicketDraft } from './types'

export default function SupportTicketDraftSaver({
  principalId,
  entryKey,
  idempotencyKey,
  origin
}: {
  principalId: string
  entryKey: string
  idempotencyKey: string
  origin?: SupportPageContext
}) {
  const { values } = useFormikContext<SupportTicketDraft>()
  const encodedOrigin = JSON.stringify(origin)
  const encodedEntities = JSON.stringify(values.affectedEntities)
  const encodedRelated = JSON.stringify(values.relatedEntities)
  const encodedPromotions = JSON.stringify(values.relatedPromotions)
  const encodedWallet = JSON.stringify(values.relatedWalletTransactions || [])
  const encodedDistribution = JSON.stringify(values.relatedDistribution)
  const encodedFailure = JSON.stringify(values.failedOperation)
  useEffect(() => {
    if (values.reporterMode !== 'CALLER') {
      clearSupportDraft(principalId)
      return
    }
    saveSupportDraft(
      principalId,
      {
        entryKey,
        idempotencyKey,
        origin: encodedOrigin
          ? {
              ...JSON.parse(encodedOrigin),
              affectedEntities: JSON.parse(encodedEntities),
              relatedEntities: JSON.parse(encodedRelated),
              relatedPromotions: JSON.parse(encodedPromotions),
              relatedWalletTransactions: JSON.parse(encodedWallet),
              relatedDistribution: JSON.parse(encodedDistribution),
              failedOperation: encodedFailure
                ? JSON.parse(encodedFailure)
                : undefined
            }
          : undefined,
        values: {
          title: values.title,
          body: values.body,
          productScope: values.productScope,
          entityType: values.entityType,
          entityCode: values.entityCode,
          attachTrace: values.attachTrace,
          traceId: values.traceId,
          traceFrom: values.traceFrom,
          traceTo: values.traceTo,
          traceServices: values.traceServices
        }
      },
      Date.now()
    )
  }, [
    principalId,
    entryKey,
    idempotencyKey,
    encodedOrigin,
    encodedEntities,
    encodedRelated,
    encodedPromotions,
    encodedWallet,
    encodedDistribution,
    encodedFailure,
    values.reporterMode,
    values.title,
    values.body,
    values.productScope,
    values.entityType,
    values.entityCode,
    values.attachTrace,
    values.traceId,
    values.traceFrom,
    values.traceTo,
    values.traceServices
  ])
  return null
}
